import { render, staticRenderFns } from "./store-tab-partial.vue?vue&type=template&id=b9c95bf2"
import script from "./store-tab-partial.vue?vue&type=script&lang=js"
export * from "./store-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports